import React from 'react';
import { Alert, Link, Modal, Space, Tooltip } from '@bedrock/components';
import POPOChatIcon from '#features/POPOChatIcon';
import classNames from 'classnames/bind';
import styles from './index.less';

const cx = classNames.bind(styles);

interface Props {
  list: {
    email?: string;
    name?: React.ReactNode;
  }[];
}

const POPOUserList: React.FC<Props> = (props: { list }) => {
  const { list } = props;
  const [visible, setVisible] = React.useState(false);

  const renderUserName = () => {
    return list.map((item, index) => (
      <>
        {item.name}
        {index !== list.length - 1 && <span>、</span>}
      </>
    ));
  };

  const renderList = () => {
    if (!list?.length) return null;
    return (
      <>
        <Tooltip title={renderUserName()} style={{ maxWidth: 200 }}>
          <div className={cx('conventional-ellipsis')}>{renderUserName()}</div>
        </Tooltip>
      </>
    );
  };

  const showPOPOChatIcon = () => {
    if (list?.length > 1) {
      return (
        <Tooltip title={'点击发起POPO对话'}>
          <POPOChatIcon
            ssid={''}
            clickFlag
            onClick={() => {
              setVisible(true);
            }}
          />
        </Tooltip>
      );
    }
    if (
      list?.length === 1 &&
      list[0]?.email &&
      list[0]?.email !== 'mpc@service.netease.com'
    ) {
      return <POPOChatIcon ssid={list[0]?.email} />;
    }
    return null;
  };

  return (
    <>
      <Space size={4}>
        {renderList()}
        {showPOPOChatIcon()}
      </Space>
      <Modal
        title="POPO对话"
        visible={visible}
        width={480}
        okButton={false}
        cancelButton={false}
        onCancel={() => setVisible(false)}
        zIndex={2000}
        renderFooter={null}
      >
        <div className={cx('modal-content-title')}>
          请选择需要 POPO 对话的人员
        </div>
        {list?.map((item) => {
          return (
            <div className={cx('modal-user-item')} key={item?.id}>
              <Space size={4}>
                <span>
                  <span>{item?.name}</span>
                  <span>{`(${item?.email})`}</span>
                </span>
                <POPOChatIcon ssid={item?.email} />
              </Space>
            </div>
          );
        })}

        <Alert
          className={cx('modal-alert')}
          type="info"
          message={
            <div>
              <div>若无法打开POPO对话窗口，请升级客户端版本。</div>
              <div>
                <span>升级地址：</span>
                <Link
                  type="primary"
                  href="http://popo.netease.com"
                  target="_blank"
                >
                  http://popo.netease.com
                </Link>
              </div>
            </div>
          }
        />
      </Modal>
    </>
  );
};
export default POPOUserList;
